import React, { Component } from 'react';
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';
import { FormattedMessage, injectIntl } from "react-intl";
import { toast } from "react-toastify";
import { handleRequestError, Request } from '../../helpers/request'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'

class FormPartnerPage extends Component
{
    state = {
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        company: '',
        job_title: '',
        conditions_accepted: false,
        loading: false
    };

    submit(e) {
        e.preventDefault();

        const { intl } = this.props;
        this.setState({ loading: true });

        const { firstname, lastname, phone, email, company, job_title } = this.state;

        Request.post('partners/submit', {
            firstname,
            lastname,
            phone,
            email,
            company,
            job_title
        })
            .then(() => {
                toast.success(
                    intl.formatMessage({
                        id: "portfolio.form_contact.message_sent",
                        defaultMessage: "Votre message a bien été envoyé."
                    })
                );

                this.props.history.push(addLocalePrefix('/'));
            })
            .catch((e) => {
                handleRequestError(e);
                this.setState({ loading: false });
            });
    }

    toggleConditionsAccepted() {
        this.setState({ conditions_accepted: !this.state.conditions_accepted });
    }

    render() {
        const { intl } = this.props;

        return (
            <div className="form-partner-page">
                <section className="partner-form">
                    <Container>
                        <div className="form-head">
                            <h1 className="line-heading" style={{whiteSpace: 'pre-line'}}>
                                <FormattedMessage
                                    id="portfolio.form_partner.title"
                                    values={{ br: <br /> }}
                                    defaultMessage={"J'aimerais développer un partenariat {br} avec Urban Linker"}
                                />
                            </h1>
                            <p>
                                <FormattedMessage
                                    id="portfolio.form_partner.subtitle"
                                    defaultMessage="Vous représentez un incubateur, une école, un bootcamp ou une Business School et vous souhaitez mettre en place un partenariat ? Laissez-nous un message et nous reviendrons vers vous dans les 48h."
                                />
                            </p>
                        </div>
                        <div className="partner-form-wrap">
                            <Form onSubmit={(e) => this.submit(e)}>
                                <div className="fields-row">
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_partner.firstname.label"
                                                defaultMessage="Prénom*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_partner.firstname.placeholder",
                                                    defaultMessage: "Pierre"
                                                })
                                            }
                                            value={this.state.firstname}
                                            onChange={(e) => this.setState({ firstname: e.target.value })}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_partner.lastname.label"
                                                defaultMessage="Nom*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_partner.lastname.placeholder",
                                                    defaultMessage: "Durand"
                                                })
                                            }
                                            value={this.state.lastname}
                                            onChange={(e) => this.setState({ lastname: e.target.value })}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_partner.phone.label"
                                                defaultMessage="Téléphone*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_partner.phone.placeholder",
                                                    defaultMessage: "Pour vous appeler"
                                                })
                                            }
                                            value={this.state.phone}
                                            onChange={(e) => this.setState({ phone: e.target.value })}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="fields-row">
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_partner.email.label"
                                                defaultMessage="Email*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="email"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_partner.email.placeholder",
                                                    defaultMessage: "Pour vous écrire"
                                                })
                                            }
                                            value={this.state.email}
                                            onChange={(e) => this.setState({ email: e.target.value })}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_partner.position.label"
                                                defaultMessage="Titre*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_partner.position.placeholder",
                                                    defaultMessage: "Ex : Chargé(e) de partenariats"
                                                })
                                            }
                                            value={this.state.job_title}
                                            onChange={(e) => this.setState({ job_title: e.target.value })}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>
                                            <FormattedMessage
                                                id="portfolio.form_partner.company.label"
                                                defaultMessage="Entreprise*"
                                            />
                                        </Label>
                                        <Input
                                            required
                                            type="text"
                                            className="input-field"
                                            placeholder={
                                                intl.formatMessage({
                                                    id: "portfolio.form_partner.company.placeholder",
                                                    defaultMessage: "Votre entreprise"
                                                })
                                            }
                                            value={this.state.company}
                                            onChange={(e) => this.setState({ company: e.target.value })}
                                        />
                                    </FormGroup>
                                </div>

                                <div className="btn-wrap checkbox-wrap">
                                    <div className="custom-control checkbox-wrap mb-5 warning">
                                        <Input
                                            required
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="posibility"
                                            onChange={() => this.toggleConditionsAccepted()}
                                        />
                                        <Label className="custom-control-label" htmlFor="posibility">
                                            <span className="box-block mr-3"/>
                                            <span className="check-text">
                                            <FormattedMessage
                                                id="portfolio.form.cgu"
                                                defaultMessage="En cochant la case, vous confirmez avoir lu et accepté les conditions d'utilisation de vos données listées {link}."
                                                values={{
                                                    link: (
                                                        <LocaleLink to={'/cgu'} className={'link-cgu'} target='_blank'>
                                                            <FormattedMessage
                                                                id="myurban.header.notifications.new_application_to_job_order.here"
                                                                defaultMessage={'ici'}
                                                            />
                                                        </LocaleLink>
                                                    )
                                                }}
                                            />
                                            </span>
                                        </Label>
                                    </div>
                                    <Button
                                        className="btn btn-warning"
                                        disabled={this.state.loading}
                                    >
                                        <FormattedMessage
                                            id="portfolio.form_partner.button"
                                            defaultMessage="ENVOYER"
                                        />
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Container>
                </section>
            </div>
        )
    }
}

export default injectIntl(FormPartnerPage);
